export const getAccelerometerReadings = () => {
  return {
    dx: 0,
    dy: 0,
    dz: 0,
  };
};
